import React from 'react';
import { ALL } from '~/features/base/constants/filterOptions';
import { CampaignStatus } from '~/api/models/campaign';

const CampaignStatusTabs = ({ statusSelected, onStatusSelection, filteredResults, allCampaigns }) => {
    const allStatuses: CampaignStatus[] = ['DRAFT', 'IN_PROGRESS', 'PAUSED', 'CANCELED', 'COMPLETED'];

    return (
        <ul className='nav nav-pills'>
            <li className={`${statusSelected === ALL ? 'active' : ''}`}>
                <div className='display-flex align-items-center gap-10' onClick={() => onStatusSelection(ALL)}>
                    <span className={'title'}>ALL</span>
                    <div
                        className='width-40 height-20  rounded-small border-width-1 border-style-solid display-flex align-items-center justify-content-center padding-top-2 padding-bottom-2'>
                        <span>{Object.values(filteredResults).flat().length}</span>
                    </div>
                </div>
            </li>
            {allStatuses.map(status => (
                <li key={status} className={`${statusSelected === status ? 'active' : ''}`}>
                    <div className='display-flex align-items-center gap-10' onClick={() => onStatusSelection(status)}>
                        <span className={'title'}>{status.toUpperCase().replace(/_/g, ' ')}</span>
                        <div
                            className='width-40 height-20   rounded-small border-width-1 border-style-solid display-flex align-items-center justify-content-center'>
                            <span>{filteredResults[status]?.length || 0}</span>
                        </div>
                    </div>
                </li>
            ))}
        </ul>
    );
};

export default CampaignStatusTabs;
